// The detector's document-type vocabulary (Tier B prompt) — the "Change type" picker.
export const DOC_TYPES = [
  'police_report', 'incident_report', 'supplemental_report', 'arrest_report', 'probable_cause_statement',
  'witness_statement', 'victim_statement', 'suspect_statement', 'interview_summary', 'interview_transcript',
  'lab_report', 'forensic_report', 'autopsy_report', 'medical_record', 'search_warrant', 'affidavit',
  'evidence_log', 'chain_of_custody', 'property_receipt', 'dispatch_log', 'cad_report', 'k9_report',
  'correspondence', 'cover_sheet', 'photo_album', 'other',
];

export const fmtType = (t) => (t ? String(t).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '');
